
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import TestimonialCard from "./TestimonialCard";

const TestimonialsSection = () => {
  const testimonials = [
    {
      text: "Had issues with a faulty phone case that the seller kept refusing to refund. SnapRefund helped me write a professional email that actually worked - got my $67 back after two weeks of trying on my own.",
      author: "Jessica D.",
      location: "New York, USA",
      avatarFallback: "JD",
      rating: 4,
      amount: "$67",
      type: "refund"
    },
    {
      text: "Ordered a laptop that arrived damaged. The seller initially refused my refund request, but the formal letter SnapRefund helped me create made all the difference. Got my $1,187 back through PayPal dispute.",
      author: "Sarah K.",
      location: "Toronto, Canada",
      avatarFallback: "SK",
      rating: 4,
      amount: "$1,187",
      type: "refund"
    },
    {
      text: "Amazing service! My refund request for a defective headset was rejected twice, but SnapRefund's AI-generated letter with legal tone got me my money back within 3 days. Saved me $89 and a lot of frustration.",
      author: "Michael R.",
      location: "London, UK",
      avatarFallback: "MR",
      rating: 5,
      amount: "$89",
      type: "refund"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-white">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900">
            Success Stories
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
            See how our users successfully recovered their money
          </p>
        </div>
        
        <div className="grid gap-6 lg:grid-cols-3 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard 
              key={index}
              text={testimonial.text}
              author={testimonial.author}
              location={testimonial.location}
              avatarFallback={testimonial.avatarFallback}
              rating={testimonial.rating}
              amount={testimonial.amount}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
